<template>
  <div class="LaisseMoiSortir">
        <div class="Comics container-fluid">

          <div id="buttonsTop row" >
            <div id="first" class="col-3">
              <div :class="prevBtn"  @click="firstOrLast(0)">
                <img src="@/assets/visual/gamecomic/first.png">
              </div>
            </div>
            <div id="previous" class="col-3">
              <div :class="prevBtn"  @click="changeImg(-1)">
                <img src="@/assets/visual/gamecomic/previous.png">
              </div>
              </div>
            <div id="next" class="col-3">
              <div :class="nextBtn" @click="changeImg(1)">
                <img src="@/assets/visual/gamecomic/next.png">
              </div>
            </div>
            <div id="last" class="col-3">
              <div :class="nextBtn" @click="firstOrLast((comics.length - 1))">
                <img src="@/assets/visual/gamecomic/last.png">
              </div>

            </div>
          </div>
                <div class="row introLaisseMoiSortir">
                  <div class="col-12">
                    <strong>Short story</strong><br>
                    Exposition at the Angoulême International Comic Festival, 2011. Publication in the festival's "young talents" magazine.

                  </div>
                </div>
          <div class="row laissemoisortir" >
            <div class="col-12">
              <img id="comicHere" :src="getMainImage">
            </div>
            
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'LaisseMoiSortir',
  data: () =>({
      comics: [
            {"picture" : require("@/assets/visual/letmeout/image1.png") , "title" : "one"},
            {"picture" : require("@/assets/visual/letmeout/image2.png") , "title" : "two"},
            {"picture" : require("@/assets/visual/letmeout/image3.png") , "title" : "three"},
      ],
      myIndex : 0,
      mainImage: '',
  }),
  mounted: function(){

    this.mainImage = this.comics[this.myIndex].picture

  },
  methods: {
    firstOrLast: function(number){
       // set the images as first or last comic

      this.mainImage = this.comics[number].picture
      this.myIndex = number
    },
    changeImg: function(number){
      if(this.myIndex == 0 && number < 0){
        // don't go back. Stay at 0
        return
      }else if(this.myIndex > this.comics.length -1) {
        this.myIndex = this.comics.length - 1
      }else{
        console.log(this.myIndex)
        this.myIndex += number
        this.mainImage = this.comics[this.myIndex].picture
      }
    }
  },
computed:{
    getTitle: function(){
        return this.titleImage
    },
    getMainImage: function(){
        return this.mainImage
    },
    nextBtn: function(){
      if (this.myIndex >= this.comics.length-1){
        return {disableCtrlBtn:true}
      }else{
        return {ctrlBtn:true}
      }
    },
    prevBtn: function(){
      if (this.myIndex <= 0){
        return {disableCtrlBtn:true}
      }else{
        return {ctrlBtn:true}
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#comicHere{
  display: block;
  max-width: 100%;
  max-height: 100%;
}
.laissemoisortir{
  padding-top:3%;
  width:95%;
}
.introLaisseMoiSortir{
    text-align: justify;
    padding:5% 20% 5% 10%;
    font-family: 'Open Sans', sans-serif;
    font-size: 0.8em;
}
.ctrlBtn{
  border: none;
  padding:10px;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: #fff;
  background-color: rgb(236, 234, 234);
  border: none;
  border-radius: 35px;
  box-shadow: 0 5px rgb(212, 212, 212);
}

.disableCtrlBtn{
  border: none;
  padding:10px;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  font-size: 24px;
  text-align: center;
  cursor: pointer;
  outline: none;
  color: #fff;
  background-color: rgb(236, 234, 234);
  border: none;
  border-radius: 35px;
  transform: translateY(4px);
  opacity: 0.2;
}

.ctrlBtn:hover{
  background-color:#d8d7d7;
  box-shadow: 0 5px rgb(94, 255, 148);
}

.ctrlBtn:active{
  box-shadow: 0 5px rgb(84, 155, 116);
  transform: translateY(4px);
}

div#numberhere{
   margin-left:auto;
   margin-right:auto;
   margin-top:2%;
   margin-bottom:2%;
   display:block;
   text-align:center;
}

#comicHere{
  margin-left:auto;
   margin-right:auto;
   display:block;
   text-align:center;
}

div #first, div#previous,  div#next, div#last {
	display:inline;
	margin-left:1%;
	margin-right:1%;
}
div#previous {
	padding-right:2%;
}

div#next {
	padding-left:2%;
}

div#buttonsTop {
	padding-top:0px;
}

</style>
